export const THEME = {
    palette: {
        primary: {
            5: {
                color: "#e1eefb",
                contrast: "#1F2A33",
            },
            light: {
                color: "#cbe1f7",
                contrast: "#1F2A33",
            },
            base: {
                color: "#1D6DC0",
                contrast: "#ffffff",
            },
            dark: {
                color: "#1a63af",
                contrast: "#ffffff",
            },
        },
        secondary: {
            light: {
                color: "#ede7fa",
                contrast: "#1F2A33",
            },
            base: {
                color: "#6C42D3",
                contrast: "#ffffff",
            },
            dark: {
                color: "#5d2fcc",
                contrast: "#ffffff",
            },
        },
        accent: {
            light: {
                color: "#5BE2EC",
                contrast: "#1F2A33",
            },
            base: {
                color: "#068089",
                contrast: "#ffffff",
            },
            dark: {
                color: "#00636A",
                contrast: "#ffffff",
            },
        },
        success: {
            light: {
                color: "#c8f4dc",
                contrast: "#1F2A33",
            },
            base: {
                color: "#1C874C",
                contrast: "#ffffff",
            },
            dark: {
                color: "#187240",
                contrast: "#ffffff",
            },
        },
        warning: {
            light: {
                color: "#fcf3d7",
                contrast: "#1F2A33",
            },
            base: {
                color: "#EFC440",
                contrast: "#1F2A33",
            },
            dark: {
                color: "#81640b",
                contrast: "#ffffff",
            },
        },
        error: {
            light: {
                color: "#f8d9d9",
                contrast: "#1F2A33",
            },
            base: {
                color: "#A82020",
                contrast: "#ffffff",
            },
            dark: {
                color: "#931c1c",
                contrast: "#ffffff",
            },
        },
        instructorIssues: {
            light: {
                color: "#E65050",
                contrast: "#ffffff",
            },
            dark: {
                color: "#E65050",
                contrast: "#ffffff",
            },
        },
        resourceIssues: {
            light: {
                color: "#E65050",
                contrast: "#ffffff",
            },
            dark: {
                color: "#E65050",
                contrast: "#ffffff",
            },
        },
        gray: {
            black: {
                color: "#1F2A33",
                contrast: "#ffffff",
            },
            slate: {
                color: "#354551",
                contrast: "#ffffff",
            },
            charcoal: {
                color: "#435969",
                contrast: "#ffffff",
            },
            silver: {
                color: "#566f80",
                contrast: "#1F2A33",
            },
            smoke: {
                color: "#D5DFE7",
                contrast: "#1F2A33",
            },
            aliceBlue: {
                color: "#E9F1F6",
                contrast: "#1F2A33",
            },
            cloud: {
                color: "#ced7df",
                contrast: "#1F2A33",
            },
            fog: {
                color: "#F3F9FC",
                contrast: "#1F2A33",
            },
            mist: {
                color: "#FAFDFF",
                contrast: "#1F2A33",
            },
            white: {
                color: "#FFFFFF",
                contrast: "#1F2A33",
            },
        },
    },
    transitions: {
        background: "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    },
    breakpoints: {
        small: 768,
        medium: 992,
        large: 1200,
    },
    sizes: {
        small: 300,
        smallplus: 400,
        medium: 600,
        large: 900,
    },
};
export const TMS_THEME = {
    ...THEME,
    typography: {
        h1: {
            fontSize: 30,
            fontWeight: 300,
        },
        h2: {
            fontSize: 21,
            fontWeight: 300,
        },
        h3: {
            fontSize: 19,
            fontWeight: 300,
        },
        p: {
            fontSize: 14,
            fontWeight: 400,
        },
        strong: {
            fontSize: 14,
            fontWeight: 500,
        },
        statusLabel: {
            fontSize: 12,
            fontWeight: 700,
            textTransform: "capitalize",
        },
    },
    root: {
        borderRadius: "4px",
        boxShadow: `0px 2px 5px 1px ${THEME.palette.gray.smoke.color}`,
    },
};
export const PORTAL_THEME = {
    ...THEME,
    typography: {
        h1: {
            fontSize: 21,
            fontWeight: 600,
        },
        h2: {
            fontSize: 18,
            fontWeight: 700,
        },
        h3: {
            fontSize: 16,
            fontWeight: 700,
        },
        p: {
            fontSize: 13,
            fontWeight: 400,
        },
        strong: {
            fontSize: 13,
            fontWeight: 500,
        },
        statusLabel: {
            fontSize: 11,
            fontWeight: 700,
            textTransform: "capitalize",
        },
    },
    root: {
        borderRadius: "4px",
        boxShadow: `0px 2px 5px 1px ${THEME.palette.gray.smoke.color}`,
    },
};
